import mrpStyles from './mrpJp.json'
import mediaQuery from './mediaQuery'
import * as theme from './mrp/index'
import * as themeJp from './mrpJp/index'
import motionSpecs from './motionSpecs'

export default {
  direction: 'ltr',
  typography: mrpStyles,
  baseOverrides: theme.baseOverrides,
  breakpoints: theme.breakpoints,
  spacingMultiplier: 8,
  rowOffsetTopSmall: 3,
  rowOffsetTopMedium: 4,
  rowOffsetTopLarge: 6,
  rowOffsetTopXLarge: 6,
  rightOffset: 3,
  fullBleed: true,
  mediaQuery,
  motionSpecs,
  custom: {
    ...theme,
    ...themeJp
  }
}
